import axios from 'axios';

import { API_CONFIG } from '@/config/api.config';

// Crie uma instância do Axios
const api = axios.create({
    //adapter: ['xhr', 'http', 'fetch'],
    baseURL: API_CONFIG.BASE_URL, // Substitua pela URL base da sua API
    withCredentials: true, // Essencial para autenticação baseada em cookies
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

let authToken = localStorage.getItem(API_CONFIG.TOKEN_KEY);

export const setAuthToken = (token) => {
    if(token && token == null) {
        authToken = null;
    } else {
        authToken = token;
    }

    return authToken;    
};

// Adicione um interceptor para requisições
api.interceptors.request.use(
    (config) => {
        // Adicione o token de autenticação aqui, se necessário
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        return config;
    },
    (error) => {
        if(error.response) {
            console.log(`Erro: ${error.response.data}`);
            console.log(`Erro: ${error.response.status}`);
            console.log(`Erro: ${error.response.headers}`);
        }else if(error.request) {
            console.log(`Erro: ${error.request}`);
        }
        // Erros que ocorrem ANTES da requisição ser enviada
        return Promise.reject(error);
    }
);

// Adicione um interceptor para respostas
api.interceptors.response.use(
    (response) => {
        // Retorna a resposta diretamente se for bem-sucedida
        return response;
    },
    (error) => {
        // Qualquer código de status que esteja fora do range 2xx aciona esta função
        // Apenas rejeita a promessa com o erro original do Axios
        return Promise.reject(error);
    }
);

export default api;